import { render, staticRenderFns } from "./cvideoflow.vue?vue&type=template&id=bb3f118c&lang=pug&"
import script from "./cvideoflow.vue?vue&type=script&lang=js&"
export * from "./cvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./cvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports